"use client";

import { BenefitsSection } from "@/components/sections/benefits";
import { benefits } from "@/lib/data/services-competitive-intelligence";

export function Benefits() {
  return (
    <BenefitsSection
      eyebrow={benefits.eyebrow}
      title={benefits.title}
      accent={benefits.accent}
      gridCols={benefits.gridCols}
      benefits={benefits.benefits}
    />
  );
}